import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

const styles: StyleRulesCallback = ({ spacing: { unit } }) => ({
  breadcrumbs: {
    padding: `${unit}px 0 0`
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
